import Input, {InputRef} from '@/components/Input';
import {Popup} from '@baidu/luffy-comp-popup';
import {SidebarSearchList} from './listNew';
import {useEffect, useRef, useState} from 'react';
import * as store from '@/store';
import sdk from '@/sdk';
import kuPiper from '@/middleware/kuPiper';
import {SearchSvg, SideBarSearchClose} from '@/icons';
import {useHistory} from 'react-router';
import {data} from './interface';
import {getRepoId, getDocType, getUUID} from './utils';
import {
    renderSidebarSearchList,
    clickSidebarSearchListItem,
    slideSidebarSearchListItem,
    sidebarSearchError,
} from '@/buried/common';
interface IProps {
    visible: boolean;
    onBlur: () => void;
    canCreateDoc: boolean;
    onFocus?: () => void;
    onValueChange?: (value: string) => void;
    defaultValue?: string;
    placeholder?: string;
}

export function Search(props: IProps) {
    const {onBlur, visible, onValueChange, defaultValue, canCreateDoc, placeholder} = props;
    // value为input输入的词组
    const [value, setValue] = useState(defaultValue || '');
    const [luffyInputBox, setLuffyInputBox] = useState<HTMLElement>();
    const [list, setList] = useState<any[]>([]);
    const inputRef = useRef<InputRef>(null);
    const [hasMore, setHasMore] = useState(true);
    const [error, setError] = useState(false);
    const [showList, setShowList] = useState(false);
    const getDataTimeoutId = useRef<NodeJS.Timeout>();
    const timeOutId = useRef<NodeJS.Timeout>();
    const history = useHistory();
    const renderReportData = useRef<any>({});
    const needReport = useRef(false);
    const blurTimeId = useRef<NodeJS.Timeout>();
    const [loading, setLoading] = useState(false);
    const searchValue = useRef('');

    function resetStatus() {
        setValue('');
        setList([]);
        setError(false);
        setHasMore(true);
        setShowList(false);
    }

    function getDataApi(page = 1) {
        const repositoryGuid = getRepoId();
        searchValue.current = value.trim();
        if (!searchValue.current) {
            return;
        }
        if (repositoryGuid) {
            setHasMore(true);
            Object.assign(
                renderReportData.current,
                {
                    timestamp_fe_request: Date.now().toString(),

                }
            );
            // 基于数据渲染完成列表之后需要上报数据
            needReport.current = true;
            setLoading(true);
            // 换词重新搜索先把原来的列表干掉
            if (page === 1) {
                setList([]);
            }
            sdk.as.getRepoDocSide({
                pageNo: page,
                pageSize: 30,
                word: value.trim() || '',
                repoGuid: [repositoryGuid],
            }).then(result => {
                Object.assign(
                    renderReportData.current,
                    {
                        timestamp_fe_response: Date.now().toString(),
                    }
                );
                const {data: {data, total, searchInfo, totalPage, keyWord, pageNo}} = result;
                if (keyWord !== searchValue.current || pageNo !== page) {
                    // 搜索词和页数有一个和当前值不同则表名这个搜索是别的时机触发的不应该渲染在视图上
                    return;
                }
                setError(false);
                setHasMore(page < totalPage);
                if (data) {
                    if (page === 1) {
                        setList(data);
                    } else {
                        data.length > 0 && setList([
                            ...list,
                            ...data,
                        ]);
                    }
                    Object.assign(
                        renderReportData.current,
                        {
                            timestamp_render_start: Date.now().toString(),
                            show_list_size: total.toString(),
                            query_id: searchInfo.queryId,
                            show_list_detail: data.map((item: data) => {
                                return {
                                    title: item.title.replace((/<em>|<\/em>/g), ''),
                                    creator: item.creator,
                                    last_update_time: item.lastUpdateTime,
                                    type: item.docType,
                                    doc_guid: item.docGuid,
                                };
                            }),
                        }
                    );
                }
            }).catch(err => {
                setError(true);
                setHasMore(false);
                if (page === 1) {
                    setList([]);
                }
                const data = {
                    'name': 'request_timeout',
                    'query_id': getUUID(),
                    'query': value,
                    'status_code': err.code.toString(),
                    'error_msg': err.message,
                    'doc_type': getDocType().toString(),
                };
                sidebarSearchError(data);
            }).finally(() => {
                setLoading(false);
            });
        }
    }

    function getData(page = 1) {
        getDataTimeoutId.current && window.clearTimeout(getDataTimeoutId.current);
        if (!value) {
            return;
        }
        getDataTimeoutId.current = setTimeout(() => {
            getDataApi(page);
        }, 200);
    }

    function handleChange(e: any) {
        if (e.target) {
            setValue(e.target.value);
        }
    }

    function handleClickClear() {
        // 点击会发生在失焦，所以需要阻止失焦重新聚焦
        blurTimeId.current && window.clearTimeout(blurTimeId.current);
        inputRef.current && inputRef.current.focus();
        setValue('');
    }

    function handleReload() {
        blurTimeId.current && window.clearTimeout(blurTimeId.current);
        inputRef.current && inputRef.current.focus();
    }

    const prefix = <SearchSvg />;
    const suffix = (
        value
            ? (<div
                onClick={handleClickClear}
            >
                <SideBarSearchClose />
            </div>)
            : null
    );

    useEffect(() => {
        if (visible) {
            inputRef.current && inputRef.current.focus();
            if (inputRef.current && value) {
                const inputDom = document.querySelector('.sidebar-search input');
                inputDom && (inputDom as HTMLInputElement).select();
            }
            const inputBox = document.querySelector('.sidebar-search .brick-input') as HTMLElement;
            inputBox && setLuffyInputBox(inputBox);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible]);

    const isClickSearchItem = useRef(false);  // 记录是否点击了搜索项
    function handleClickItem(item: data, index: number) {
        if (!item.url) {
            return;
        }
        // 需要补充字段
        const data = {
            'name': 'show_list_click',
            'query_id': renderReportData.current.query_id,
            'query': value,
            'title': item.title.replace((/<em>|<\/em>/g), ''),
            'creator': item.creator,
            'doc_type': item.docType,
            'pos_absolute': (index + 1).toString(),
            'doc_id': item.docGuid,
            'KU_name': item.repoName,
            'KU_id': item.repoGuid,
            'last_update_time': item.lastUpdateTime,
        };
        // 埋点
        clickSidebarSearchListItem(data);
        const routePath = item.url.split('/knowledge')[1];
        const jumpProxy = kuPiper.runProxy(kuPiper.proxyNameMap.sidebarSearchClickJump, (path: string) => {
            path && window.open(path, '_blank');
        });
        jumpProxy(`/knowledge${routePath}`);
        // 点击搜索项
        isClickSearchItem.current = true;
    }

    function getScreenIndex() {
        // 获取列表滚动到了第几屏
        const listDom = document.querySelector('.sidebar-search-list');
        if (!listDom) {
            return '';
        }
        const scrollNum = listDom.scrollTop / 264;
        return scrollNum === 0
            ? '1'
            : Math.ceil(scrollNum).toString();
    }

    function handleLoadMore(page: number) {
        getDataApi(page);
        const data = {
            'name': 'load_more',
            'query_id': getUUID(),
            'query': value,
            'total_screen': getScreenIndex(),
            'doc_type': getDocType().toString(),
        };
        slideSidebarSearchListItem(data);
    }

    function clearValue() {
        // 一分钟之后清除输入内容
        timeOutId.current = setTimeout(() => {
            resetStatus();
        }, 1000 * 60);
    }

    function handleBlur() {
        // 点击事件发生之后再失焦
        blurTimeId.current = setTimeout(() => {
            // 如果点击了搜索项，不执行失焦清理
            if (isClickSearchItem.current) {
                isClickSearchItem.current = false;  // 重置标志
                return;  // 跳过失焦操作
            }
            clearValue();
            onBlur && onBlur();
        }, 300);
    }

    function handleFocus() {
        timeOutId.current && window.clearTimeout(timeOutId.current);
        // handleLoadMore(1);
    }

    useEffect(() => {
        // 监听页面的点击事件
        const handleClickOutside = (event: MouseEvent) => {
            if (luffyInputBox && !luffyInputBox.contains(event.target as Node)) {
                handleBlur(); // 触发失焦操作，关闭搜索框
            }
        };

        // 当页面可见时开始监听点击事件
        if (visible) {
            document.addEventListener('click', handleClickOutside);
        }

        // 清理事件监听
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [visible, luffyInputBox]);

    useEffect(() => {
        if (value) {
            onValueChange && onValueChange(value || '');
            getData();
            setShowList(!!value.trim());
        } else {
            resetStatus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    function handleRenderEnd(tim: number) {
        if (!needReport.current || list.length === 0) {
            return;
        }
        needReport.current = false;
        // 列表完成渲染
        Object.assign(
            renderReportData.current,
            {
                timestamp_render_end: tim.toString(),
            }
        );
        const data = {
            name: 'query_process',
            query: value,
            doc_type: getDocType(),
            ...renderReportData.current,
        };
        renderSidebarSearchList(data);
    }

    if (!visible) {
        return null;
    }

    return (<div>
        <Input
            placeholder={placeholder}
            onBlur={handleBlur}
            onFocus={handleFocus}
            ref={inputRef}
            onChange={handleChange}
            prefix={prefix}
            suffix={suffix}
            value={value}
            // 没有添加文档的icon的时候占满本行
            style={
                canCreateDoc
                    ? {}
                    : {
                        right: '4px',
                    }
            }
        />
        {
            luffyInputBox
                ? <Popup
                    portalContainer={luffyInputBox}
                    // 加载已经完成或者列表为空的时候不展示
                    visible={showList}
                    destroyOnHide={false}
                >
                    <SidebarSearchList
                        list={list}
                        onClickItem={handleClickItem}
                        loadMore={handleLoadMore}
                        hasMore={hasMore}
                        error={error}
                        renderEnd={handleRenderEnd}
                        loading={loading}
                        onReload={handleReload}
                        word={value}
                    />
                </Popup>
                : null
        }
    </div>);
}
